import styles from "./PickupBadges.module.css"
import { PICKUP_PRESETS } from "./pickupPresets.js"
import type { Filters } from "./useBenefits.js"

interface Props {
  filters: Filters
  onChange: (partial: Partial<Filters>) => void
}

export function PickupBadges({ filters, onChange }: Props) {
  return (
    <div className={styles.row}>
      {PICKUP_PRESETS.map((preset) => {
        const active = preset.isActive(filters)
        return (
          <button
            key={preset.id}
            type="button"
            className={`${styles.badge} ${active ? styles.active : ""}`}
            aria-pressed={active}
            onClick={() => onChange(active ? preset.clearFilters : preset.getFilters())}
          >
            {preset.label}
          </button>
        )
      })}
    </div>
  )
}
